import { StatusBadge, type StatusTone } from "@/components/ui/status-badge";

interface Props {
  status: string;
}

const toneOf = (status: string): StatusTone => {
  switch (status.toLowerCase()) {
    case "active":
      return "success";
    case "cancelled":
      return "danger";
    default:
      return "neutral";
  }
};

export const SubscriptionTag = ({ status }: Props) => (
  <StatusBadge tone={toneOf(status)}>{status || "Active"}</StatusBadge>
);
